import { CircularProgress, Grid, Pagination } from "@mui/material";
import GapAround from "../../components/hoc/GapAround";
import FlexibleColumns from "../../components/layout/FlexibleColumns";
import SubscribeNewsletter from "./SubscribeNewsletter";
import BlogListing from "./BlogListing";
import { storyBlockApi } from "../../utils/apiClient";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMediaQueries } from "../../contexts/media-query";
import BlogTrending from "./BlogTrending";
import { formatBlogPosts } from "./blogHelpers";
import useBlogData from "../../components/hooks/UseBlogData";
import SubscribeButton from "../../components/buttons/SubscribeButton";
import classNames from "classnames";
import LoadingContainer from "./LoadingContainer";

const BlogArticles = ({ selectedType, scrollTargetRef, page, setPage }: any) => {
  const { isLessThan1150, isLargeThan899, bigColumnClass } = useMediaQueries();
  const innerColumnWidth = !isLargeThan899 ? 12 : 6;
  const columWidths = isLessThan1150 ? [12] : [7, 5];
  const containerStyle = !isLessThan1150 ? bigColumnClass : {};
  const { loading, blogPosts, total } = useBlogData(selectedType, page);
  const viewLess = total == blogPosts.length;
  const firstBlogRef = useRef<HTMLDivElement | null>(null);
  const hasPaginated = useRef(false);
  const [showNoPosts, setShowNoPosts] = useState(false);
  const SubscribeButtonLabel = viewLess ? 'View Less' : 'View More'
  function handleMobilePagination(){
    setPage((page: number) => {
      let changedPage = page;
      hasPaginated.current = true; // ✅ same here
      if (viewLess) {
        return changedPage - 1;
      }
      return changedPage + 1;
    });
  }
  useEffect(() => {
    if (hasPaginated.current && !loading && scrollTargetRef.current) {
      scrollTargetRef.current.scrollIntoView({ behavior: 'smooth', block: 'start'});
      hasPaginated.current = false;
    }  
  }, [page, loading]);

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => {
        setShowNoPosts(blogPosts.length === 0);
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setShowNoPosts(false);
    }
  }, [loading, blogPosts.length]);

  return (
    <div className={isLessThan1150 ? 'mx-4' : ''}>
      <GapAround
        spaceTaken={2}
        className={classNames({ 'mt-7': !isLessThan1150, '-mt-3': isLessThan1150 })}
        containerStyle={containerStyle}>
            {loading && isLessThan1150 && blogPosts.length === 0 && <LoadingContainer size={60} />}
        <FlexibleColumns containerStyle={bigColumnClass} columnWidths={columWidths}>
          <Grid className="full-height spacing-sm" container spacing={4} width={'100%'}  sx ={{minHeight: 'calc(100% - 50px)',}}>
            {loading && (
                 <Grid item xs={12}>
                    <LoadingContainer size={60} smallHeight/>
                </Grid>
            )}
            {showNoPosts ? (
              <div className="text-center py-[40px] !block w-full">No posts found</div>
            ) : (
              blogPosts.map((blog: any, idx: number) => (
                <Grid item xs={innerColumnWidth} key={blog._id}>
                  <div className={`blog-item ${loading ? '' : 'loaded'}`} ref={idx === 0 ? firstBlogRef : null}>
                    <BlogListing blog={blog} loading={loading} />
                  </div>
                </Grid>
              ))
            )}
            {(!isLessThan1150 && total > 0) ? (
              <div style={{ width: '100%' }} className='my-10'>
                <Pagination
                  className="w-full"
                  count={Math.ceil(total / 6)}
                  page={page}
                  size="large"
                  onChange={(_, page) => {hasPaginated.current = true; setPage(page)}}
                />
              </div>
            ) : (total > 0) && (
              <div className='flex justify-center w-full mt-5 mb-8 xl:mb-0'>
                <SubscribeButton
                  label={SubscribeButtonLabel}
                  onClick={handleMobilePagination}
                  cursor
                />
              </div>
            )}
          </Grid>

          <div>
            {/* <SubscribeNewsletter /> */}
            <BlogTrending />
          </div>
        </FlexibleColumns>
      </GapAround>
    </div>
  );
};

export default BlogArticles;
